import SvgIcon from '@home/components/SvgIcon';
import React, { useMemo, useState } from 'react';
import { Button, Modal, ModalProps } from 'tea-component';
import BubbleCommon, { TipsMapType } from '@op/components/BubbleCommon';
import { useIntl } from 'umi';
import './index.scss';
import { BubbleCommonType } from '@op/components/BubbleCommon/BubbleCommon';

const commonTipsMap: TipsMapType = {
  en: 'View table in full screen',
  zh: '全屏查看表格',
};

export default function useFullScreen() {
  const [visible, setVisible] = useState(false);
  const { formatMessage } = useIntl();

  const ScreenModal = useMemo(() => {
    return function ScreenModal({
      children,
      title,
      hasRightIcon = true,
      ...props
    }: {
      hasRightIcon?: boolean;
      title?: string | any;
      children: any;
    } & ModalProps) {
      if (!visible) return null;

      return (
        <Modal
          className={`dbo-full-screen-wrapper ${hasRightIcon ? '--has-right-icon' : ''}`}
          visible={true}
          size="l"
          onClose={() => setVisible(false)}
          caption={title}
          {...props}
        >
          <Modal.Body>{children}</Modal.Body>
          <Modal.Footer>
            <Button type="primary" onClick={() => setVisible(false)}>
              {formatMessage({ id: 'Close' })}
            </Button>
          </Modal.Footer>
        </Modal>
      );
    };
  }, [visible, formatMessage]);

  function FullIcon({
    className,
    style,
    type = 'focus-icon',
    title,
    tipsMap = commonTipsMap,
    placement = 'top',
    ...props
  }: {
    show?: boolean;
    className?: string;
    style?: React.CSSProperties;
    type?: string;
    title?: any;
    tipsMap?: TipsMapType;
  } & BubbleCommonType) {
    return (
      <div className="dbo-full-icon-title">
        <label>{title}</label>
        <BubbleCommon
          tipsMap={tipsMap}
          showIcon={false}
          placement={placement}
          {...props}
        >
          <SvgIcon
            type={type}
            className={`dbo-full-icon ${className}`}
            style={style}
            onClick={() => setVisible(true)}
          ></SvgIcon>
        </BubbleCommon>
      </div>
    );
  }

  return { ScreenModal, FullIcon, setVisible };
}
